import { P } from "../../../../../../AbstractElements";
import CommonFileUpload from "../../../../../CommonComponents/CommonFileUpload";
import ProductGallery from "./ProductGallery";

const ProductTwo = () => {
  return (
    <div className="sidebar-body">
      <div className="product-upload">
        <P>
          Product Image<span className="text-danger"> *</span>
        </P>
        <CommonFileUpload />
      </div>
      <ProductGallery />
    </div>
  );
};

export default ProductTwo;
